<template>
    <c-q-btn
      id="back-button"
      propBtnLabel="Voltar"
      :propBtnFunction="backToPreviousPage"
      :propBtnTransparent="true"
      :propBtnSize="EnumButtonSizes.LARGE_1"
    >
    </c-q-btn>
  </template>
  
<script setup lang="ts">
import { EnumButtonSizes, EnumRouteNames } from '@/enums/enums'
import { useRouter } from 'vue-router'
import { useInstitutionalStore } from '@/stores/institutionalStore'

const router = useRouter()
const institutionalStore = useInstitutionalStore()

const backToPreviousPage = () => {
  // ✅ garante que o accordion saiba que está voltando da review
  institutionalStore.setVeioDaReview(true)

  const id = router.currentRoute.value.params.id

  // ✅ SE TEM ID → volta para EDIT
  if (id) {
    router.push({
      name: EnumRouteNames.INSTITUTIONAL_EDIT,
      params: { id }
    })
    return
  }

  // ✅ SE NÃO TEM ID → volta para NEW
  router.push({
    name: EnumRouteNames.INSTITUTIONAL_NEW
  })
}
</script>
  
  <style scoped>
  
  </style>